import React, { useState, useEffect } from 'react';

/**
 * Simple toast notification system
 * Provides toast notifications for user feedback
 */

// Toast container component
export const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  // Add toast to the list
  const addToast = (message, type = 'info') => {
    const id = Date.now();
    const newToast = { id, message, type };
    
    setToasts(prev => [...prev, newToast]);
    
    // Auto remove after 3 seconds
    setTimeout(() => {
      setToasts(prev => prev.filter(toast => toast.id !== id));
    }, 3000);
  };

  // Make addToast available globally
  useEffect(() => {
    window.showToast = addToast;
    return () => {
      delete window.showToast;
    };
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <div key={toast.id} className={`toast toast-${toast.type}`}>
          {toast.message}
          {/* <button 
            className="toast-close" 
            onClick={() => setToasts(prev => prev.filter(t => t.id !== toast.id))}
            aria-label="Close toast"
          >
            ×
          </button> */}
        </div>
      ))}
    </div>
  );
};

// Hook for using toast
export const useToast = () => {
  const showToast = (message, type = 'info') => {
    if (window.showToast) {
      window.showToast(message, type);
    }
  };

  return { showToast };
};

const toastUtils = { ToastContainer, useToast };
export default toastUtils;
